export default "__VITE_ASSET__OtgYgT0b__"